<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目名称：" prop="projectName">
              <el-input  maxlength="100" v-model="ruleForm.projectName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="委托单位：" prop="manageUnit">
              <el-input  maxlength="100" v-model="ruleForm.manageUnit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目编号：" prop="exNumber">
              <el-input maxlength="100" v-model="ruleForm.exNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">确定</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        projectName: '',
        exNumber: '',
        manageUnit: '',
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        /*exNumber: [
          { required: true, message: '请输入项目编号', trigger: 'blur' }
        ],*/
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '请输入用户id', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.ruleForm, true);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
}
</script>

<style lang='less' scoped>
.addModel{
  height: 320px;
  padding: 0 20px;
  .addfrom{
    margin: 0 30px;
    .topcontent{
      margin-bottom: 20px;
      .el-row{
        margin-bottom: 0;
        height: 40;
      }
    p{
        padding: 0 10px;
      }
    }
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      /deep/.el-input__inner{
        height: 33px;
        // width: 90%;
      }
      /deep/.el-select{
        width: 160px;
        /deep/.el-input__inner{
          width: 100%;
        }
      }
      .el-col-7,.el-col-8,.el-col-9{
        height: 32px;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-form-item__label{
        padding: 0;
        // text-align: justify;
        // text-align-last: justify;
      }
    }
  }
  /deep/.el-button{
    width: 100px;
  }
  .footer{
    text-align: center;
    margin-top: 50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/components/addProject.vue